import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { Button } from '@mui/material';

import { DatalineStatus } from 'src/constants/dataline';
import type { DashboardDataline } from 'src/types/dashboard';
import { OnDemandReportsDownloadContextProvider } from 'src/components/dashboard/DashboardPage/components/ButtonReportModal/contexts/onDemandReportsDownloadContext';

import ReportModalDialog from './components/reportModalDialog';
import ReportModalSnackbar from './components/reportModalSnackbar';

export interface ButtonReportModalProps {
  dataline?: DashboardDataline;
}

export const BUTTON_REPORT_MODAL_BUTTON_TEST_ID = 'button-report-modal-button';

const ButtonReportModal: FC<ButtonReportModalProps> = ({ dataline }) => {
  const { t } = useTranslation(['dashboard', 'common']);
  const [showModal, setShowModal] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [unavailableReportTypes, setUnavailableReportTypes] = useState<
    number[]
  >([]);

  useEffect(() => {
    if (!dataline) {
      setShowButton(false);
      return;
    }
    setShowButton(dataline.status === DatalineStatus.STATUS_OK);
  }, [dataline]);

  return showButton ? (
    <OnDemandReportsDownloadContextProvider>
      <Button
        variant="cta"
        color="primary"
        startIcon={<DownloadRounded />}
        onClick={() => setShowModal(true)}
        data-test-id={BUTTON_REPORT_MODAL_BUTTON_TEST_ID}
      >
        {t('dashboard:ButtonReportModal.DownloadReports')}
      </Button>
      <ReportModalDialog
        showModal={showModal}
        closeDialog={() => setShowModal(false)}
        setUnavailableReportTypes={setUnavailableReportTypes}
      />
      <ReportModalSnackbar
        unavailableReportTypes={unavailableReportTypes}
        setUnavailableReportTypes={setUnavailableReportTypes}
      />
    </OnDemandReportsDownloadContextProvider>
  ) : null;
};

export default ButtonReportModal;
